import {
  DevolucionCumplimiento,
  DevolucionCumplimientoFiltro,
  DevolucionCumplimientoResultado,
  AnularCumplimientosRequest
} from '../../model/devolucion-cumplimiento/devolucion-cumplimiento';

/**
 * Puerto Abstracto: DevolucionCumplimientoRepository
 *
 * Define el contrato para consulta y anulación de cumplimientos.
 * Legacy: DevolucionCumplimientosFacade.java
 */
export abstract class DevolucionCumplimientoRepository {

  /**
   * Consulta cumplimientos disponibles para devolución.
   * SP: PCK_PSC_PROGRAMAR_ORDENES.SP_PSC_GET_CUMPLIM_DEVOLUCION
   *
   * @param page página 0-based (el backend la traduce a inudesde/inuhasta del SP)
   * @param size tamaño de página (1..MAX_PAGE_SIZE)
   */
  abstract listarCumplimientos(
    filtro: DevolucionCumplimientoFiltro,
    page: number,
    size: number
  ): Promise<DevolucionCumplimiento[]>;

  /**
   * Ejecuta la devolución/anulación de cumplimientos.
   * SP: PCK_PSC_PROGRAMAR_ORDENES.SP_PSC_DEV_CUMPLIMIENTOS
   */
  abstract anularCumplimientos(
    request: AnularCumplimientosRequest
  ): Promise<DevolucionCumplimientoResultado>;
}
